"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageUrl = exports.ImageSizes = void 0;
var react_1 = __importStar(require("react"));
var imagebox_1 = __importDefault(require("./imagebox"));
var thumbnail_1 = __importDefault(require("./thumbnail"));
var ImageSizes;
(function (ImageSizes) {
    ImageSizes["THUMBNAIL"] = "320x240";
    ImageSizes["MEDIUM"] = "640x480";
    ImageSizes["LARGE"] = "1024x768";
})(ImageSizes = exports.ImageSizes || (exports.ImageSizes = {}));
exports.getImageUrl = function (id, dim) {
    if (dim === void 0) { dim = ImageSizes.THUMBNAIL; }
    return "https://images.opentalk.today/thumbnails/" + id + "_" + dim;
};
var Imagex = function (props) {
    var id = props.id;
    var _a = react_1.useState(false), displayLightbox = _a[0], setDisplayLightbox = _a[1];
    var handleClickEvent = function (id) {
        setDisplayLightbox(!displayLightbox);
    };
    return (react_1.default.createElement("div", { className: "message-image" },
        react_1.default.createElement(thumbnail_1.default, { id: id, handleClickEvent: handleClickEvent }),
        displayLightbox && react_1.default.createElement(imagebox_1.default, { id: id })));
};
exports.default = Imagex;
